/**
 * Webhooks & Integrations settings section.
 *
 * Renders the Kondo integration (webhook URL + team API keys) and the
 * Webhooks & API Keys management panel. Gated by the `inbound_webhooks`
 * feature flag at the nav config level.
 */

import { KondoIntegration } from '@/components/KondoIntegration';
import { WebhooksApiKeysSection } from '@/components/WebhooksApiKeysSection';
import { useViewHealthMarker } from '@/lib/view-health';

import { InboundWebhooksSection } from './inbound-webhooks-section';

export function WebhooksSection() {
  useViewHealthMarker('settings-section-ready');
  return (
    <div className='space-y-8'>
      <div>
        <h2 className='text-lg font-semibold text-fg-primary'>Webhooks</h2>
        <p className='text-sm text-fg-tertiary mt-0.5'>
          Manage webhook integrations and API keys.
        </p>
      </div>
      <InboundWebhooksSection />
      <div className='space-y-6'>
        <KondoIntegration />
        <WebhooksApiKeysSection />
      </div>
    </div>
  );
}
